import React from 'react';
import PropTypes from 'prop-types';

const ButtonSpinner = ({ loading, color, size }) => {
  if (!loading) {
    return null;
  }

  let iconClass;
  if (size === 's') {
    iconClass = 'icon--s';
  } else {
    iconClass = 'icon--m';
  }

  return (
    <div className={`spin-loader spin-loader--${color}`}><span className={`spin-loader__icon icon ${iconClass}`} /></div>
  );
};

ButtonSpinner.propTypes = {
  loading: PropTypes.bool,
  color: PropTypes.string,
  size: PropTypes.string,
};

export default ButtonSpinner;



// WEBPACK FOOTER //
// ./library/app/components/Global/Buttons/ButtonSpinner.js